<template>
  <div class="row " >
      <div class="col-md-12 col-sm-12 page-tools-container-bar animate-box " >
          <div class="archives archive-arabic-page-tools">

            <div >
              <div style="text-align: right">
              <!-- <img src="/img/tools/toolicon_print.gif" title="Link(s) may open a new browser window. Close window to return to this page." alt=""> -->
              <!--<a :href="CONTENT_DOMAIN+'/scripts/print/print_page.php?id_cr='+content_id" target="_blank" v-html="languageData['print']"></a>  | -->
              <a :href="CONTENT_DOMAIN+'/new_eesite_print_page.php?id_cr='+content_id+'&id_language='+$store.state.companyData['id_language']+'&id_company='+$store.state.companyData['id_company']+'&id_country='+$store.state.companyData['id_country']" target="_blank" v-html="languageData['print']"></a><span aria-hidden="true"> | </span>
              
              <!-- <img src="/img/tools/toolicon_email.gif" title="email" alt=""> -->
              
              <!-- <script type="text/javascript">document.write('');</script> 
              
              onclick="window.open('/forms/feed_back?id=28378', 'Feedback', 'toolbar=no, directories=no, location=no, status=yes, menubar=no, resizable=yes, scrollbars=yes, width=500, height=590'); return false"-->

              <a href="" style="margin-left:3px;" v-html="languageData['feedback']" target="_blank" @click="call_feedback()"></a>
              </div>

              <div class="email-tools">
                <form method="post" action="" id="frmemail">
                <!-- <img src="../img/tools/toolicon_email.gif" title="Email" alt=""> -->
                <div class="form-row">
                <label for="toemail" v-html="languageData['emailto']"></label>
                <input type="email" ref="toEmail" name="toemail" id="toemail" v-model="to_email" required=""  @blur="validatenow($event)" class="label-input pr-label" autocomplete="email">
                </div>
                <div class="form-row">
                <label for="fromemail" class="label2-input" v-html="languageData['emailfrom']"></label>
                <input type="email" class="" name="fromemail" id="fromemail" v-model="from_email" required=""  @blur="validatenow($event)" autocomplete="email">
                </div>
                
                <input type="button" name="submit" :value="decodeHtmlLang(languageData['sendPDF'])" @click="sendpdf()" class="button small btn-primary button-padding">
                
                </form>
              </div>	
              <label v-html="returnmsg" aria-live="assertive" class="label-align" ></label>	
              <!-- <img src="../img/tools/toolicon_link.gif" alt=""> -->
              <!-- <span class="pageTools">Link(s) may open a new browser window. Close window to return to this page.		</span> -->
            </div>


          </div>
          
      </div>
  </div>
</template>

<script>
//import {CONTENT_DOMAIN} from '@/constants/general_constants';
import axios from 'axios';
  
export default {
    name: 'PageTools',
    data() {
      return {
        CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
        FORM_ACTION_DOMAIN:this.$store.state.FORM_ACTION_DOMAIN,
        to_email:'',
        from_email:'',
        msg1:'',
        msg2:'',
        logo1:'',
        logo2:'',
        content_id:this.$route.params.id,
        returnmsg:'',
        footer_nav_status:this.$store.state.themeLogic.footers.footer
      };                
    },
    directives: {
      //sticky: Sticky 
    },
    //props: ['top', 'scrollY'],
    computed:{
       languageData(){return this.$store.state.languageData;}
    },   
    components:{
        
    },
    mounted :function(){
      
      //this.loadExternalScript("https://engagementengineoffline.powerflexweb.com/scripts/poll_default/index.php?controller=pjFront&action=pjActionLoadJS"),
      //this.loadExternalScript("https://engagementengineoffline.powerflexweb.com/scripts/poll_default/index.php?controller=pjFront&action=pjActionLoad&id=36")


    },
    
    methods:{
        validatenow: function(e){
          var emailidd=e.target.value;
          if(this.validateEmailid(emailidd)){
            this.returnmsg=this.languageData['pleaseEmailFormat'];
            //e.target.focus();
          }
          else{this.returnmsg="";}
        },

        sendpdf(){

            if(this.validateEmailid(this.to_email)){
            this.returnmsg=this.languageData['pleaseEmailFormat'];
            this.$refs.toEmail.focus();
          }
          else if(this.validateEmailid(this.from_email)){
            this.returnmsg=this.languageData['pleaseEmailFormat'];
            this.$refs.fromEmail.focus();
          }
          else{
            this.returnmsg="";
          //console.log('sendpdf')
          //$_SESSION['name_company'] == 'tsn' || $_SESSION['name_company'] == 'TSN'
          const config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                   
                }
            }
            const formData = new FormData()
            formData.append('toemail', this.to_email)
            formData.append('fromemail', this.from_email)
            formData.append('id_cr', this.content_id)
            formData.append('logo1', this.logo1) // need to get from 
            formData.append('logo2', this.logo2)
            formData.append('msg1', this.msg1)
            formData.append('msg2', this.msg2)
            formData.append('id_company', this.$store.state.companyData['id_company'])
            formData.append('id_language', this.$store.state.companyData['id_language'])
            formData.append('id_country', this.$store.state.companyData['id_country'])            
            formData.append('id_eap', this.$store.state.companyData['id_eap'])
            //alert('frmdata'+formData)
           
            axios.post(this.FORM_ACTION_DOMAIN+'/new_eesite_forms/send_pdf.php',formData,config)
            .then(response => {
                
                //console.log('forreturn-',response)
                if(response === undefined || response.length == 0 ){
                    //console.log('invalid')
                    this.returnmsg='! Something went wrong, Please try again'
                }
                else{
                  this.returnmsg = response.data
                  this.to_email=''
                  this.from_email=''
                  
                  if(this.returnmsg=='All fields are required'){
                    this.$refs.toEmail.focus();
                  }
                    
                }
                
            })
            .catch(() => {                
                this.returnmsg='Try after sometime'
            });
          }



        },

        call_feedback(){
          window.open('/forms/feed_back?id='+this.content_id, 'Feedback', 'toolbar=no, directories=no, location=no, status=yes, menubar=no, resizable=yes, scrollbars=yes, width=500, height=590');
        },

        loadExternalScript(path_to_file){
            //console.log('calling create scr wow');
            const plugin = document.createElement("script");
            plugin.setAttribute(
            "src",
            path_to_file
            );
            plugin.async = true;
            document.body.appendChild(plugin);
        }
      }
}
</script>

<style scoped>
.page-tools-container-bar{
    
    margin-bottom: 30px;
    
    /*position: sticky;
    top: 0;*/
}

.email-tools{
  padding: 7px 0;
  text-align: center;
}
.email-tools input{
  padding: 3px;
    height: 26px;
    margin: 0 7px; 
    line-height: 18px;
}

.a-box {
  display: inline-block;
  /* //height: 5rem;
  //width: 5rem; */
  border: 2px solid blue;
  position: relative;
  z-index: 9999;
}
.archives{
    padding: 1em 1em 1em 1em;
    margin-bottom: 0px;
    margin-right: 0px;
}
.form-row {
  display: inline-block;
  }
.label-input {
  margin: 0 0 0 32px !important;
}
.form-row {
  display: inline-block;
}
.button-padding {
  padding: 3px 10px !important;
} 
.label-align {
  text-align: center;
  display: block;
}
@media only screen and (min-width: 400px) and (max-width: 1080px) {
  .form-row {
  display: block;
  }
  
}
@media only screen and (max-width: 400px) {
 .label-input {
  margin: 0 0 0 32px !important;
}
  .form-row {
  display: block !important;
  }
/* .label2-input {
  margin: 0 0 0 32px !important;
} */
  
}
@media only screen and (max-width: 382px) {
  .pr-label{
    display: flex !important;
    margin: 0 0 0 53px !important;
}
}

@media only screen and (max-width: 1080px) {
  .label2-input {
    padding-left: 8px !important;
  }
}
 .label2-input {
    padding-left: 16px;
  }
</style>